import { forwardRef, type Ref, type SVGProps } from "react";
const IconTargetOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m26.86 9.129 2.992-2.993a.502.502 0 0 0-.346-.857h-2.783v-2.78a.5.5 0 0 0-.857-.349l-2.992 2.992a.5.5 0 0 0-.14.35v2.37l-.678.669-1.15 1.15-.977.985-1.426 1.415-2.174 2.175a2.992 2.992 0 1 0 1.416 1.418l2.172-2.173 1.417-1.427.985-.977 1.15-1.15.669-.679h2.373c.13 0 .255-.05.35-.14"
    />
    <path
      fill="currentColor"
      d="M25.404 24.8a13 13 0 0 0 2.603-7.842 12.9 12.9 0 0 0-1.337-5.707l-.08.005-.079.006h-2.104q.05.085.1.166l.11.183A10.987 10.987 0 0 1 14.27 27.93a10.984 10.984 0 0 1-8.004-17.587 10.984 10.984 0 0 1 14.12-2.962q.09.052.175.104l.175.105V5.487q0-.04.005-.08l.005-.08A13.002 13.002 0 0 0 2.05 15.846a13.006 13.006 0 0 0 16.552 13.646 13 13 0 0 0 6.801-4.692"
    />
    <path
      fill="currentColor"
      d="M19.914 20.472a6.02 6.02 0 0 0 .903-5.057l1.571-1.572a7.98 7.98 0 0 1-8.11 11.054A7.976 7.976 0 0 1 8.43 12.495a7.98 7.98 0 0 1 9.728-2.884l-1.572 1.572a6.013 6.013 0 1 0 3.328 9.289"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTargetOutlineSVG);
ForwardRef.displayName = "IconTargetOutline";
export { ForwardRef as IconTargetOutline };
